import React,
{
  createContext,
  useContext,
  useState
} from 'react';

const HelpContext =
  createContext(null);

export function HelpProvider({
  children
}) {

  const [isOpen, setIsOpen] =
    useState(false);

  const [topic, setTopic] =
    useState('how-everyid-works');

  const openHelp = (
    topicId = 'how-everyid-works'
  ) => {

    setTopic(topicId);
    setIsOpen(true);

  };

  const closeHelp = () =>
    setIsOpen(false);

  return (

    <HelpContext.Provider
      value={{
        isOpen,
        topic,
        setTopic,
        openHelp,
        closeHelp
      }}
    >

      {children}

    </HelpContext.Provider>

  );

}

export function useHelp() {

  return useContext(
    HelpContext
  );

}
